// Header 0.5 col padding
// Menu 0.75 col padding
//  Left 2 col width with 0.75 col padding
//  Right 1.75 col width with 0.75 col padding
//
// On 5, looks like 1.25 col width with 0.5 col padding + 3.75 sides
// on 3, looks like 2.25 col width max with 0.5 col padding + 2.25 sides
//

const config = {
  types: [
    "phones",
    "tablets",
    "laptops",
    "special-ops",
    "headphones",
    "watches",
    "power-and-cables",
    "bags-and-sleeves",
    "gears",
  ],
  typeData: {
    phones: {
      label: "Phone",
      columns: 5,
      showClearance: true,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 6,
        },
        {
          brand: "samsung",
          devicesToShow: 6,
        },
        {
          brand: "google",
          devicesToShow: 4,
        },
      ],
      showOtherBrands: true,
      otherBrandsLabel: "More Phone Cases",
      otherBrands: ["motorola", "huawei", "lg", "oneplus", "xiaomi"],
      showSeries: true,
      series: [
        "monarch",
        "pathfinder",
        "civilian",
        "plyo",
        "metropolis",
        "plasma",
      ],
    },
    tablets: {
      label: "Tablet",
      columns: 5,
      showClearance: true,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 6,
        },
        {
          brand: "microsoft",
          devicesToShow: 6,
        },
        {
          brand: "samsung",
          devicesToShow: 6,
        },
      ],
      showOtherBrands: true,
      otherBrandsLabel: "More Tablet Cases",
      otherBrands: ["lg", "tcl"],
      showSeries: true,
      series: [
        "monarch",
        "pathfinder",
        "civilian",
        "plyo",
        "metropolis",
        "plasma",
      ],
    },
    laptops: {
      label: "Laptop",
      columns: 3,
      showClearance: false,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 5,
        },
        {
          brand: "microsoft",
          devicesToShow: 4,
        },
      ],
      showOtherBrands: true,
      otherBrandsLabel: "More Laptop Cases",
      otherBrands: ["dell", "hp-laptops-and-tablets", "lenovo"],
      showSeries: false,
      series: [],
    },
    "special-ops": {
      link: "/collections/special-ops/",
      label: "Original Art",
    },
    headphones: {
      label: "Headphones",
      columns: 2,
      showClearance: true,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 5,
        },
        {
          brand: "samsung",
          devicesToShow: 6,
        },
      ],
      showOtherBrands: false,
      otherBrandsLabel: "",
      otherBrands: [],
      showSeries: false,
      series: [],
    },
    watches: {
      label: "Watch",
      columns: 3,
      showClearance: false,
      featuredBrands: [
        {
          brand: "apple",
          devicesToShow: 2,
        },
        {
          brand: "samsung",
          devicesToShow: 1,
        },
        {
          brand: "urban-armor-gear",
          devicesToShow: 2,
        },
      ],
      showOtherBrands: false,
      otherBrandsLabel: "",
      otherBrands: [],
      showSeries: false,
      series: [],
    },
    "power-and-cables": {
      link: "/collections/urban-armor-gear-power-and-cables/",
      label: "Power",
    },
    "bags-and-sleeves": {
      link: "/collections/urban-armor-gear-bags-and-sleeves/",
      label: "Bags & Sleeves",
    },
    gears: {
      link: "/collections/gears/",
      label: "Gear",
    },
  },
}

export default config
